

































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SwapResponsibleDialog from '@/components/Dialogues/SwapResponsibleDialog.vue';
import ResponsibleSettingsDialog from '@/components/Dialogues/ResponsibleSettingsDialog.vue';

@Component({
  components: { ResponsibleSettingsDialog, SwapResponsibleDialog }
})
export default class EditCutoverplanDefaultTab extends Vue {
  @Watch('cutoverplan.responsibles')
  watchResponsibles() {
    this.refreshResponsiblesByEnv();
  }

  @Prop()
  cutoverplan?: any;

  @Prop()
  selectedEnvironment?: number;

  get environmentsForSelect() {
    return this.cutoverplan.environments?.map((environment: any) => ({
      text: environment.name,
      value: environment.id
    }));
  }

  get environmentsWithDefault() {
    const envs = [{ id: 'null', name: 'Default' }];
    if (this.cutoverplan?.environments?.length) {
      envs.push(...this.cutoverplan.environments);
    }
    return envs;
  }

  responsiblesByEnv: any = {};

  selected_responsible_id: any = -1;

  selected_role_id: any = -1;

  selected_name: any = '';

  environment: any = {};

  selected_environment_id = -1;

  responsibleCurrentlyEditing: object = {};

  showResponsibleSettingsDialog = false;

  updateResponsiblesByEnv = false;

  addResponsible() {
    this.cutoverplan.responsibles?.push({
      cutoverplan_id: this.cutoverplan.id,
      role_id: this.selected_role_id,
      responsible_id: this.selected_responsible_id,
      environment_id: this.selected_environment_id
    });
  }

  async handleShowResponsibleSettingsDialog(responsible: any) {
    this.responsibleCurrentlyEditing = responsible;
    this.showResponsibleSettingsDialog = true;
  }

  removeResponsible(responsible: any) {
    const index = this.cutoverplan.responsibles?.indexOf(responsible);
    if (index !== undefined && index > -1) {
      this.cutoverplan.responsibles?.splice(index, 1);
    }
  }

  refreshResponsiblesByEnv() {
    this.updateResponsiblesByEnv = true;

    this.responsiblesByEnv = {};
    this.cutoverplan.responsibles?.forEach((responsible: any) => {
      if (!this.responsiblesByEnv[responsible.environment_id]) {
        this.responsiblesByEnv[responsible.environment_id] = [];
      }
      this.responsiblesByEnv[responsible.environment_id].push(responsible);
    });
    this.updateResponsiblesByEnv = false;
  }

  async created() {
    this.cutoverplan.responsibles?.forEach((responsible: any) => {
      if (!this.responsiblesByEnv[responsible.environment_id]) {
        this.responsiblesByEnv[responsible.id] = [];
      }
      this.responsiblesByEnv[responsible.id].push(responsible);
    });
  }

  mounted() {
    this.refreshResponsiblesByEnv();
  }
}
